import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { getApiHeader } from 'utlis/commonfunctions';
import done from '../../../../assets/images/done.png';

import {
    Alert,
    Card,
    CardHeader,
    CardContent,
    Grid,
    Box,
    Collapse,
    IconButton,
    AlertTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";

const CustomerRegistration = ({ planData,totalZero, onFormSubmit, handleParOrderSuccessData }) => {

    console.log("totalZero------->",totalZero);
    
    const [clientToken, setClientToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [open, setOpen] = useState(true);
    const [formData, setFormData] = useState({
        first_name: "",
        last_name: "",
        email: "",
        plan_name: planData.plan_name,
        actual_amount: planData.actual_amount,
        plan_amount: planData.plan_amount,
        plan_id: planData.plan_id
    });


    const [showPaymentSection, setShowPaymentSection] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const navigate = useNavigate();
    const apiUrl = process.env.REACT_APP_API_URL;

    const [paymentStatus, setPaymentStatus] = useState(true)
    const [agreedToTerms, setAgreedToTerms] = useState(false);


    const [defaultCard, setdefaultCard] = useState([]);
    const [existingCard, setExistingCard] = useState(0);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleZeroTotalWithWallet = async (payment_method_token) => {
        const headers = await getApiHeader();
        try {
            setLoading(true);
            const response = await axios.post(`${apiUrl}international-esim/esim-checkout-payment-submit`, { 'payment_method_token': payment_method_token }, { headers: headers });

            if (response?.status === 200) {
                console.log("Default Card Payment Success:", response?.data?.data?.data);
                handleParOrderSuccessData(response?.data?.data?.data);
            } else {
                console.error("Default Card Payment Failed:", response?.data);
                alert("Payment failed. Please try again.");
            }
        } catch (error) {
            console.error("Default Card Payment Error:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        if (formData.email !== formData.confirm_email) {
            setLoading(false);
            setError("Emails do not match.");
            return;
        }
        const headers = await getApiHeader();

        try {
            const response = await axios.post(`${apiUrl}international-esim/rtap-activation-to-esim`, formData, { headers: headers });
            const { payment_method_token } = response.data.data;
            
            if (totalZero === true && planData.retailerType !== "PAR"){
                handleZeroTotalWithWallet(payment_method_token)

                setFormData({
                    first_name: "",
                    last_ame: "",
                    email: "",
                    confirm_email: "",
                });
                return;
            } 
            
            planData.retailerType === "PAR" ? handleParOrderSuccessData(response?.data?.data) : onFormSubmit(payment_method_token);
            // Reset form
            setFormData({
                first_name: "",
                last_ame: "",
                email: "",
                confirm_email: "",
            });

        } catch (error) {
            console.error("API Error:", error.response.data.message);
            setError(error.response.data.message? error.response.data.message : "An Error has been Occured.Please Contact Telsim Dealer Support.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <Card sx={{ boxShadow: 3 }}  >
                <CardHeader
                    title="Customer Registration"
                    sx={{
                        textAlign: "center",
                        backgroundColor: "#e20e75",
                        color: "white",
                    }}
                    titleTypographyProps={{ style: { color: "white" } }}
                />
                <CardContent>
                    <div className="customer-registration-form">
                        <form onSubmit={handleSubmit} autoComplete="off">
                            {error && <div className="alert alert-danger">{error}</div>}
                            <div className="form-group mb-3">
                                <label htmlFor="firstName" className="form-label">
                                    Customer First Name<span style={{ color: 'red' }}> *</span>
                                </label>

                                <input
                                    autoComplete="new-password" 
                                    type="text"
                                    className="form-control p-3"
                                    id="first_name"
                                    name="first_name"
                                    placeholder="Customer name"
                                    value={formData.first_name}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            handleChange(e); // Only update if the input is valid
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="lastName" className="form-label">
                                    Customer Last Name<span style={{ color: 'red' }}> *</span>
                                </label>
                                <input
                                    autoComplete="new-password" 
                                    type="text"
                                    className="form-control p-3"
                                    id="last_name"
                                    name="last_name"
                                    placeholder="Customer last name"
                                    value={formData.last_name}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^[a-zA-Z\s]*$/.test(value)) {
                                            handleChange(e); // Only update if the input is valid
                                        }
                                    }}
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="email" className="form-label">
                                    Customer Email<span style={{ color: 'red' }}> *</span>
                                </label>
                                <input
                                    autoComplete="new-password" 
                                    type="email"
                                    className="form-control p-3"
                                    id="email"
                                    name="email"
                                    placeholder="Customer Email Address"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="form-group mb-4">
                                <label htmlFor="confirmEmail" className="form-label"  >
                                    Confirm Customer Email Address<span style={{ color: 'red' }}> *</span>
                                </label>
                                <input
                                    autoComplete="new-password" 
                                    type="email"
                                    className="form-control p-3"
                                    id="confirm_email"
                                    name="confirm_email"
                                    placeholder="Confirm Customer Email Address"
                                    value={formData.confirm_email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <button
                                type="submit"
                                className="btn btn-block w-100"
                                style={{ backgroundColor: "#e20e75", color: "white" }}
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Next"}
                            </button>
                        </form>
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

export default CustomerRegistration;
